import { enableProdMode, InjectionToken } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { API_BASE_URL } from './app/shared/services/ppv.api'

export function getBaseUrl() {
   //todo: figure out what to do with this
   return environment.apiUrl
   //return document.getElementsByTagName('base')[0].href;
}

const providers = [{ provide: API_BASE_URL, useFactory: getBaseUrl, deps: [] }]

if (environment.production) {
   enableProdMode()
}

platformBrowserDynamic(providers)
   .bootstrapModule(AppModule)
   .catch((err) => console.error(err))
